var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyStoresBig = function SvgMyStoresBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my-stores-big_svg__clip0_1683_167908)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.667 20H8.333v1.667h23.334V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.333 13.333c.92 0 1.667-.747 1.667-1.666V8.333c0-.919-.748-1.666-1.667-1.666H36l-2.248-5.62A1.667 1.667 0 0032.206 0H7.795c-.682 0-1.294.415-1.548 1.048L4 6.667H1.667C.747 6.667 0 7.414 0 8.333v3.334c0 .919.748 1.666 1.667 1.666h1.666v25H0V40h40v-1.667h-3.333v-25h1.666zM7.795 1.667h24.41l2 5H5.795l2-5zm-6.128 10V8.333h36.666l.001 3.334H1.667zM10 38.333V26.667h6.667v11.666H10zm13.333 0V26.667H30v11.666h-6.667zm11.667 0h-3.333V26.667c0-.92-.748-1.667-1.667-1.667h-6.667c-.919 0-1.666.747-1.666 1.667v11.666h-3.334V26.667c0-.92-.747-1.667-1.666-1.667H10c-.92 0-1.667.747-1.667 1.667v11.666H5v-25h30v25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-stores-big_svg__clip0_1683_167908"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgMyStoresBig;